import { ChatvoltService } from './chatvolt.service';
import { Injectable } from "@angular/core"
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpContext,
  HttpErrorResponse,
} from "@angular/common/http"

import { environment } from "../../../environments/environment"
import { GrayLogService } from "src/app/cadastro/admin/services/graylog/graylog.service"

interface HttpGetOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[]
      }
  context?: HttpContext
  observe?: string
  params?: HttpParams
  reportProgress?: boolean
  responseType: string
  withCredentials?: boolean
}
import { SchoolService } from "src/app/cadastro/admin//services/school.service"
import { AccountService } from "src/app/cadastro/admin/services/account.service"
import { UserService } from "src/app/cadastro/admin/services/user.service"
import { SchoolGetRequest } from "src/app/cadastro/admin/models/school/school-get-request"
import { Observable, firstValueFrom, take } from "rxjs"
import { TenantService } from "@app/cadastro/admin"
import { SprinklrService } from "./sprinklr.service"
import { Injector } from '@angular/core';

@Injectable({
  providedIn: "root",
})
export class HelpDeskService {
  private getHelpDeskScriptEndpoint: string

  userId: string
  user: any
  currentRole: string
  filterModel: SchoolGetRequest

  constructor(
    private httpClient: HttpClient,
    private grayLogService: GrayLogService,
    private userService: UserService,
    private accountService: AccountService,
    private schoolService: SchoolService,
    private ChatvoltService: ChatvoltService,
    private injector: Injector
  ) {
    this.getHelpDeskScriptEndpoint =
      environment.endpointHelpDesk.url +
      environment.endpointHelpDesk.routes.get_help_desk_script
  }

  async fetchHelpDeskScript(params: HttpParams) {
    const headers = new HttpHeaders().set(
      "Accept",
      "text/html, application/json, */*"
    )

    return await firstValueFrom(
      this.httpClient.get<any>(this.getHelpDeskScriptEndpoint, {
        params,
        headers,
        observe: "response",
      })
    )
  }

  async init({ requestDefault } = { requestDefault: false }) {

    const tenantService = this.injector.get(TenantService)
    const tenant = await firstValueFrom(tenantService.getCurrentTenant())
    if(tenant.tenantBrandFixedKey.toLocaleLowerCase().includes("maple")) {

      if(tenant.tenantBrandId !== environment.sprinklrUris.MAPLE_GLOBAL_ID){
        this.ChatvoltService.loadChatvolt()
        return
      } else{
        return
      }
    }
    try {
      let params: HttpParams

      if (requestDefault) params = new HttpParams().set("default", "true")

      const response = (await this.fetchHelpDeskScript(params)).body

      response &&
        this.loadScript({
          script: response.Script,
          requestDefaultOnError: false,
        })
    } catch (error) {
      const script = (error as HttpErrorResponse).error?.text

      script && this.loadScript({ script, requestDefaultOnError: false })
    }
  }

  loadScript(
    { script, requestDefaultOnError } = {
      script: "",
      requestDefaultOnError: false,
    }
  ) {
    if (!script || !script.trim()) {
      return
    }

    const node = new DOMParser().parseFromString(script, "text/html").head
      .firstChild as HTMLScriptElement
    const scriptTag = document.createElement("script")

    const attributes = node.attributes

    if (attributes && attributes.length > 1) {
      for (let i = 0, j = attributes.length; i < j; ++i) {
        const attr = attributes[i]
        scriptTag.setAttribute(attr.nodeName, attr.nodeValue)
      }
    } else {
      scriptTag.src = node.src
    }

    scriptTag.onerror = (err) => {
      let full_message =
        "an error occurred while loading tenant helpdesk, loading default helpdesk..." +
        err

      this.grayLogService.logError(full_message)
      requestDefaultOnError && this.init({ requestDefault: true })
    }

    this.getScriptGlobalBot(node, scriptTag)
      .pipe(take(1))
      .subscribe((resp) => {
        scriptTag.src = resp.src
        document.body.appendChild(scriptTag)
      })
  }
  getScriptGlobalBot(
    node: HTMLScriptElement,
    scriptTag: HTMLScriptElement
  ): Observable<HTMLScriptElement> {
    return new Observable<HTMLScriptElement>((obs) => {
      const attributes = node.attributes

      if (attributes && attributes.length > 1) {
        for (let i = 0, j = attributes.length; i < j; ++i) {
          const attr = attributes[i]
          scriptTag.setAttribute(attr.nodeName, attr.nodeValue)
        }

        obs.next(scriptTag)
      } else {
        scriptTag.src = node.src
        if (scriptTag.src.includes("globalbot")) {
          this.userService.getUserInfo().subscribe(({ id }) => {
            this.userId = id

            this.accountService
              .getUserInformations(this.userId)
              .subscribe((user: any) => {
                this.user = user
                this.filterModel = new SchoolGetRequest()
                this.filterModel.TenantId = user.tenantId

                this.accountService
                  .getAllProfile(true)
                  .subscribe((data: any) => {
                    let profilesList = []
                    let userProfile

                    for (let profile of user.profiles) {
                      userProfile = data.find((item) => item.id === profile.id)
                      profilesList.push(userProfile.type)
                    }

                    this.schoolService
                      .getAllSchools(this.filterModel)
                      .subscribe((school: any) => {
                        scriptTag.src += this.mountGlobalBotURL(
                          user,
                          school,
                          profilesList
                        )

                        obs.next(scriptTag)
                      })
                  })
              })
          })
        } else {
          obs.next(scriptTag)
        }
      }
    })
  }

  mountGlobalBotURL(user: any, school: any, profilesList: any[]) {
    let phone = null

    if (user.cellPhoneNumber) {
      phone = user.cellPhoneNumber.replace(/\D/g, "")
    }

    return (
      "?identifiers=name-" +
      encodeURI(user.name.split(" ")[0]) +
      "|id_grupo_economico-" +
      encodeURI(user.tenantId.replace(/(-)/g, "_")) +
      "|grupo_economico-" +
      encodeURI(school.itens[0].tenantName.replace(/( )/g, "_")) +
      "|id_escola-" +
      encodeURI(school.itens[0].id.replace(/(-)/g, "_")) +
      "|escola-" +
      encodeURI(school.itens[0].fantasyName.replace(/( )/g, "_")) +
      "|cnpj_escola-" +
      encodeURI(school.itens[0].documentCNPJ?.replace(/\D/g, "")) +
      "|email-" +
      encodeURI(user.email) +
      "|phone-" +
      encodeURI(phone) +
      "|perfis-" +
      encodeURI(profilesList.toString())
    )
  }
}
